import React from 'react';
import { Form } from '@douyinfe/semi-ui';
import { ButtonStyleForm } from '../../components/SingleButton';
import { config } from './config';

export const BottomButtonStyleForm = ({ data = {}, onChange }) => {
    const defaultData = {
        ...config.defaultProps
    };

    const handleFormChange = (values) => {
        const newData = { ...defaultData, ...data, ...values, ['link']: values.link || '' };
        data = { ...newData }
        onChange?.(newData);
    };

    const handleChange = (values) => {
        const newData = { ...defaultData, ...data, ...values };
        data = { ...newData }
        onChange?.(newData);
    };
    return (
        <Form
            initValues={{
                link: data?.link || defaultData.link,
                animation: data?.animation || defaultData.animation,
                bottom: data?.bottom || defaultData.bottom
            }}
            onValueChange={handleFormChange}
        >
            <ButtonStyleForm data={data} onChange={handleChange} />
            <Form.Input
                field="link"
                label="点击链接"
                placeholder="请输入按钮点击后跳转的链接"
                style={{ width: '100%' }}
            />
            <Form.Select
                field="animation"
                label="动画效果"
                style={{ width: '100%' }}
            >
                <Form.Select.Option value="none">无动画</Form.Select.Option>
                <Form.Select.Option value="pulse">脉冲</Form.Select.Option>
                <Form.Select.Option value="bounce">弹跳</Form.Select.Option>
            </Form.Select>
            <Form.InputNumber
                field="bottom"
                label="底部距离"
                suffix="px"
                style={{ width: '100%' }}
                min={0}
            />
        </Form>
    );
};

export default BottomButtonStyleForm;